import defaultConfig, { LEFT, RIGHT } from '../default/config_default';
import { cloneDeep } from 'lodash';

let page = cloneDeep(defaultConfig);

page.imageSrc = 'background/strona_049.jpg';
page.images = [
  {
    imageId: 'page049_zoom0',
    rectangle: {
      x: 152,
      y: 1720,
      width: 1632,
      height: 560,
    },
    imageSrc: 'images/page049/049 3.jpg',
  },
  {
    imageId: 'page049_zoom1',
    rectangle: {
      x: 630,
      y: 797,
      width: 1240,
      height: 912,
    },
    imageSrc: 'images/page049/049 2.jpg',
  },
  {
    imageId: 'page049_zoom2',
    rectangle: {
      x: 628,
      y: 356,
      width: 1160,
      height: 424,
    },
    imageSrc: 'images/page049/049 1.jpg',
  },
];
page.games = [
  {
    id: 'page051_game11',
    icon: 'ikonaStepbystep',
    color: '#FF000000',
    pos: {
      x: RIGHT,
      y: 634,
    },
    item: {
      id: 'page051_game11',
    },
    rectangle: {
      id: 'page049_rect2',
    },
  },
  {
    id: 'page051_game12',
    icon: 'ikonaStepbystep',
    color: '#FF000000',
    pos: {
      x: RIGHT,
      y: 1397,
    },
    item: {
      id: 'page051_game12',
    },
    rectangle: {
      id: 'page049_rect1',
    },
  },
  {
    id: 'page051_game10',
    icon: 'ikonaStepbystep',

    pos: {
      x: RIGHT,
      y: 431,
    },
    item: {
      id: 'page051_game10',
    },
    rectangle: {
      id: 'page049_rect0',
    },
  },
];
page.rectangle = [
  {
    id: 'page049_rect0',

    tooltip: '',

    linked: ['page051_game10'],
    x: 138,
    y: 431,
    width: 488,
    height: 204,
  },
  {
    id: 'page049_rect1',

    tooltip: '',
    color: '#FF000000',
    linked: ['page051_game12'],
    x: 135,
    y: 1397,
    width: 491,
    height: 286,
  },
  {
    id: 'page049_rect2',

    tooltip: '',
    color: '#FF000000',
    linked: ['page051_game11'],
    x: 137,
    y: 634,
    width: 488,
    height: 763,
  },
];
export default page;
